import { defineStore } from "pinia";
import { ref } from "vue";
import { get2023Data } from "./zi/2023";
import { get2024Data } from "./zi/2024";
import type { ZiItem } from "./zi/zi_defs";

export const useZiStore = defineStore("zi", () => {
  let hasLoaded = false;
  const loaded = ref<{ img: any; type: string; name: string }[]>([]);
  const list = ref<ZiItem[]>([]);

  async function setup() {
    if (!hasLoaded) {
      hasLoaded = true;
      list.value = [...(await get2023Data()), ...(await get2024Data())];
    }
  }

  return {
    list,
    loaded,
    setup,
  };
});
